import React, { useContext } from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as GiIcons from "react-icons/gi";
import * as BsIcons from "react-icons/bs";
import * as BiIcons from "react-icons/bi";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { ArrowRight } from "./IconsV2";

export const ListPanel = ({
	items,
	textProperty,
	iconProperty,
	isComplete,
	pathProperty,
}) => {
	const getIcon = (item) => {
		let IconComponent = null;

		if (item[iconProperty].startsWith("Fa")) {
			IconComponent = FaIcons[item[iconProperty]];
		} else if (item[iconProperty].startsWith("Gi")) {
			IconComponent = GiIcons[item[iconProperty]];
		} else if (item[iconProperty].startsWith("Bs")) {
			IconComponent = BsIcons[item[iconProperty]];
		} else if (item[iconProperty].startsWith("Bi")) {
			IconComponent = BiIcons[item[iconProperty]];
		}
		if (!IconComponent) {
			return <FaIcons.FaInfoCircle />;
		}

		return <IconComponent />;
	};

	const { theme } = useContext(DiseaseGroupContext);

	const listItems = items.map((item) => (
		<li key={"item_" + item.path} className={"w-full"}>
			<Link
				to={item[pathProperty]}
				className={"lg:text-base w-full flex flex-row xl:py-3 items-center"}
			>
				{item[isComplete] && (
					<span
						className={`my-auto p-1.5 text-white ${theme.primary().bg()}`}
						style={{ borderRadius: "50%" }}
					>
						<FaIcons.FaCheck size={8} />
					</span>
				)}
				{!item[isComplete] && (
					<span
						className={`my-auto p-1.5 text-white bg-gray-300`}
						style={{ borderRadius: "50%" }}
					>
						<FaIcons.FaCheck size={8} />
					</span>
				)}
				<span className={`flex-grow pl-2 h-full`}>
					{item[textProperty]}
				</span>
				<span className={"flex items-center pr-4"}>
					<ArrowRight className={"w-4 text-black"} />
				</span>
			</Link>
		</li>
	));

	return <ul className={"panel-list max-w-panel mx-auto"}>{listItems}</ul>;
};

ListPanel.defaultProps = {
	textProperty: "text",
	iconProperty: "icon",
	isComplete: "isComplete",
	pathProperty: "path",
};
